import Balance from '../../balance/balance'
import Banner from '../../banner/banner'
import * as s from './style'

import {AiFillBank} from 'react-icons/ai'
import Graphic from '../../graphic'

function ContainerCenter(){
    return(
        <s.container>
            <Banner/>
            <div className='container__balance'>
                <Balance
                    title={'Saldo disponível'}
                    balance={685}
                    textButton={'Transferir'}
                    imgButton={<AiFillBank/>}
                    observation={'Valor sujeito a mudanças até o final do dia'}
                />
                <Balance
                    title={'Saldo a receber - Abril'}
                    balance={20.657}
                    textButton={'Visualizar detalhes'}
                    imgButton={''}
                    observation={'Lançamentos previstos para entrar na sua conta'}
                />
            </div>
            <Graphic/>
        </s.container>
    )
}


export default ContainerCenter